import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n';
import './legal.css';

export default function LegalLayout({ eyebrow, title, children }) {
  const navigate = useNavigate();
  const { t } = useI18n();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="legal-page">
      <div className="legal-top">
        <img src="/assets/hitmax_new.webp" alt="HITMAX" onClick={() => navigate('/')} draggable={false} />
        <Link to="/" className="legal-back" data-testid="legal-back">{t.legal.back}</Link>
      </div>
      <div className="legal-body">
        <p className="legal-eyebrow">{eyebrow}</p>
        <h1 className="legal-h1">{title}</h1>
        <div className="legal-content">{children}</div>
        <p className="legal-updated">{t.legal.updated}</p>
      </div>
      <div className="legal-foot">
        <div className="legal-foot-inner">
          <Link to="/confidentialite">{t.pages.confidentialite}</Link>
          <Link to="/support">{t.pages.support}</Link>
          <Link to="/mentions-legales">{t.pages.mentions}</Link>
          <Link to="/">{t.pages.home}</Link>
        </div>
      </div>
    </div>
  );
}
